export default [
  { name: "red", background: "#FFF1F0", text: "#CF1322", border: ""},
  { name: "orange", background: "#fdf2e9", text: "#e67e22", border: "" },
  { name: "yellow", background: "#FFFBE6", text: "#D48806", border: "#faf4d7" },
  { name: "green", background: "#e7f7f3", text: "#10ac84", border: "#10ac84" },
  { name: "blue", background: "#eef0ff", text: "#536DFE", border: "" },
  { name: "purple", background: "#f4ecf7", text: "#8e44ad", border: "" },
  { name: "gray", background: "#eef0f1", text: "#576574", border: "#576574" },
  { name: "black", background: "#cccccc", text: "#000000", border: "" }
]